import {
  GET_TESTS,
  GET_ALL_QUESTIONS,
  REMOVE_SINGLE_QUESTION,
  ADD_SINGLE_QUESTION,
  MINI_GAMES_LIST,
  CREATED_QUIZ,
  REMOVE_QUIZ,
  GET_GUIZ_BY_ID,
  SET_ACTIVE_QUIZ_ID,
  GET_COMMENTS_BY_ID,
  GET_QUIZ_TICKET_LIST,
  REMOVE_SINGLE_TICKET,
  GET_KEYS,
  KEYS_CURRENT_PAGE,
  KEYS_TOTAL_COUNT,
  REMOVE_KEY,
  GET_ANSWER,
  GET_SCORES,
  SCORES_TOTAL_COUNT,
  SCORES_CURRENT_PAGE,
  REMOVE_SCORE,
  TESTS_CURRENT_PAGE,
  TESTS_TOTAL_PAGES,
  GET_COINS,
  COINS_CURRENT_PAGE,
  COINS_TOTAL_COUNT,
  GET_QUIZ_CHEATS,
  QUIZ_CHEATS_CURRENT_PAGE,
  QUIZ_CHEATS_TOTAL_PAGES,
  GET_WORDS,
  WORDS_TOTAL_COUNT,
  WORDS_CURRENT_PAGE,
  REMOVE_WORD,
  GET_PARTICIPANTS,
  PARTICIPANTS_TOTAL_COUNT,
  PARTICIPANTS_CURRENT_PAGE,
  GET_VOWS,
  VOWS_CURRENT_PAGE,
  VOWS_TOTAL_COUNT,
  REMOVE_VOW,
  GET_WGEVENTS,
  WGEVENTS_TOTAL_COUNT,
  WGEVENTS_CURRENT_PAGE,
  REMOVE_WGEVENT,
  GET_ALL_MARATHON_EVENTS,
  MARATHON_EVENTS_CURRENT_PAGE,
  MARATHON_EVENTS_TOTAL_PAGES,
  GET_MARATHON_EVENT_BY_ID,
  GET_MARATHON_QUESTIONS_BY_ID,
  ADD_MARATHON_QUESTION,
  UPDATE_MARATHON_QUESTION,
  REMOVE_MARATHON_QUESTION,
  GET_MARATHON_TICKET_LIST,
  MARATHON_TICKET_LIST_CURRENT_PAGE,
  MARATHON_TICKET_LIST_TOTAL_PAGES,
  REMOVE_MARATHON_SINGLE_TICKET,
  GET_MARATHON_ANSWER,
  GET_MARATHON_SCORES,
  MARATHON_SCORES_CURRENT_PAGE,
  MARATHON_SCORES_TOTAL_PAGES,
  UPDATE_MARATHON_SCORE,
} from "../../@jumbo/constants/ActionTypes";

const INIT_STATE = {
  allTests: [],
  testsCurrentPage: 1,
  testsTotalPage: 0,
  allQuestions: [],
  miniGamesList: [],
  createdQuiz: null,
  testById: null,
  activeQuizId: "",
  commentsById: [],
  quizTicketList: [],
  keys: [],
  keysCurrentPage: 1,
  keysTotalPage: 0,
  answer: [],
  scores: [],
  scoresCurrentPage: 1,
  scoresTotalPage: 0,
  coins: [],
  coinsCurrentPage: 1,
  coinsTotalPage: 0,
  quizCheats: [],
  quizCheatsTotalPages: 0,
  quizCheatesCurrentPage: 0,
  words: [],
  wordsCurrentPage: 1,
  wordsTotalPage: 0,
  participants: [],
  participantsCurrentPage: 1,
  participantsTotalPage: 0,
  vows: [],
  vowsCurrentPage: 1,
  vowsTotalPage: 0,
  wgevents: [],
  wgeventsCurrentPage: 1,
  wgeventsTotalPage: 0,
  allMarathonEvents: [],
  marathonEventsCurrentPage: 1,
  marathonEventsTotalPages: 0,
  marathonEventById: null,
  marathonQuestionsById: [],
  marathonTicketList: [],
  marathonTicketListCurrentPage: 1,
  marathonTicketListTotalPages: 0,
  marathonAnswer: [],
  marathonScores: [],
  marathonScoresCurrentPage: 1,
  marathonScoresTotalPages: 0,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TESTS: {
      return {
        ...state,
        allTests: action.payload,
      };
    }
    case TESTS_CURRENT_PAGE: {
      return {
        ...state,
        testsCurrentPage: action.payload,
      };
    }
    case TESTS_TOTAL_PAGES: {
      return {
        ...state,
        testsTotalPage: action.payload,
      };
    }
    case GET_ALL_QUESTIONS: {
      return {
        ...state,
        allQuestions: action.payload,
      };
    }
    case GET_GUIZ_BY_ID: {
      return {
        ...state,
        testById: action.payload,
      };
    }
    case REMOVE_QUIZ: {
      return {
        ...state,
        allTests: state.allTests.filter((item) => item._id !== action.payload),
      };
    }
    case MINI_GAMES_LIST: {
      return {
        ...state,
        miniGamesList: action.payload,
      };
    }
    case CREATED_QUIZ: {
      return {
        ...state,
        createdQuiz: action.payload,
      };
    }
    case REMOVE_SINGLE_QUESTION: {
      return {
        ...state,
        allQuestions: state.allQuestions.filter(
          (item) => item._id !== action.payload
        ),
      };
    }
    case ADD_SINGLE_QUESTION: {
      return {
        ...state,
        allQuestions: [action.payload, ...state.allQuestions],
      };
    }
    case SET_ACTIVE_QUIZ_ID: {
      return {
        ...state,
        activeQuizId: action.payload,
      };
    }
    case GET_COMMENTS_BY_ID: {
      return {
        ...state,
        commentsById: action.payload,
      };
    }
    case GET_QUIZ_TICKET_LIST: {
      return {
        ...state,
        quizTicketList: action.payload,
      };
    }
    case GET_KEYS: {
      return {
        ...state,
        keys: action.payload,
      };
    }
    case KEYS_CURRENT_PAGE: {
      return {
        ...state,
        keysCurrentPage: action.payload,
      };
    }
    case KEYS_TOTAL_COUNT: {
      return {
        ...state,
        keysTotalPage: action.payload,
      };
    }
    case GET_ANSWER: {
      return {
        ...state,
        answer: action.payload,
      };
    }
    case REMOVE_KEY: {
      const toBeRemovedId = action.payload;
      const keysCopy = [...state.keys];
      if (keysCopy.lenght !== 0) {
        keysCopy.forEach((key, index) => {
          if (key._id === toBeRemovedId) {
            keysCopy.splice(index, 1);
          }
        });
      }
      return {
        ...state,
        keys: keysCopy,
      };
    }
    case REMOVE_SINGLE_TICKET: {
      return {
        ...state,
        quizTicketList: state.quizTicketList.filter(
          (item) => item._id !== action.payload
        ),
      };
    }
    case GET_SCORES: {
      return {
        ...state,
        scores: action.payload,
      };
    }
    case SCORES_CURRENT_PAGE: {
      return {
        ...state,
        scoresCurrentPage: action.payload,
      };
    }
    case SCORES_TOTAL_COUNT: {
      return {
        ...state,
        scoresTotalPage: action.payload,
      };
    }
    case REMOVE_SCORE: {
      const toBeRemovedId = action.payload;
      const scoresCopy = [...state.scores];
      if (scoresCopy.lenght !== 0) {
        scoresCopy.forEach((score, index) => {
          if (score._id === toBeRemovedId) {
            scoresCopy.splice(index, 1);
          }
        });
      }
      return {
        ...state,
        scores: scoresCopy,
      };
    }
    case GET_COINS: {
      return {
        ...state,
        coins: action.payload,
      };
    }
    case COINS_CURRENT_PAGE: {
      return {
        ...state,
        coinsCurrentPage: action.payload,
      };
    }
    case COINS_TOTAL_COUNT: {
      return {
        ...state,
        coinsTotalPage: action.payload,
      };
    }
    case GET_QUIZ_CHEATS: {
      return {
        ...state,
        quizCheats: action.payload,
      };
    }
    case QUIZ_CHEATS_CURRENT_PAGE: {
      return {
        ...state,
        quizCheatesCurrentPage: action.payload,
      };
    }
    case QUIZ_CHEATS_TOTAL_PAGES: {
      return {
        ...state,
        quizCheatsTotalPages: action.payload,
      };
    }
    case GET_WORDS: {
      return {
        ...state,
        words: action.payload,
      };
    }
    case WORDS_CURRENT_PAGE: {
      return {
        ...state,
        wordsCurrentPage: action.payload,
      };
    }
    case WORDS_TOTAL_COUNT: {
      return {
        ...state,
        wordsTotalPage: action.payload,
      };
    }
    case REMOVE_WORD: {
      const toBeRemovedId = action.payload;
      const wordsCopy = [...state.words];
      if (wordsCopy.lenght !== 0) {
        wordsCopy.forEach((word, index) => {
          if (word._id === toBeRemovedId) {
            wordsCopy.splice(index, 1);
          }
        });
      }
      return {
        ...state,
        words: wordsCopy,
      };
    }
    case GET_PARTICIPANTS: {
      return {
        ...state,
        participants: action.payload,
      };
    }
    case PARTICIPANTS_CURRENT_PAGE: {
      return {
        ...state,
        participantsCurrentPage: action.payload,
      };
    }
    case PARTICIPANTS_TOTAL_COUNT: {
      return {
        ...state,
        participantsTotalPage: action.payload,
      };
    }
    case GET_VOWS: {
      return {
        ...state,
        vows: action.payload,
      };
    }
    case VOWS_CURRENT_PAGE: {
      return {
        ...state,
        vowsCurrentPage: action.payload,
      };
    }
    case VOWS_TOTAL_COUNT: {
      return {
        ...state,
        vowsTotalPage: action.payload,
      };
    }
    case REMOVE_VOW: {
      const toBeRemovedId = action.payload;
      const vowsCopy = [...state.vows];
      if (vowsCopy.length !== 0) {
        vowsCopy.forEach((vow, index) => {
          if (vow._id === toBeRemovedId) {
            vowsCopy.splice(index, 1);
          }
        });
      }
      return {
        ...state,
        vows: vowsCopy,
      };
    }
    case GET_WGEVENTS: {
      return {
        ...state,
        wgevents: action.payload,
      };
    }
    case WGEVENTS_CURRENT_PAGE: {
      return {
        ...state,
        wgeventsCurrentPage: action.payload,
      };
    }
    case WGEVENTS_TOTAL_COUNT: {
      return {
        ...state,
        wgeventsTotalPage: action.payload,
      };
    }
    case REMOVE_WGEVENT: {
      const toBeRemovedId = action.payload;
      const wgeventsCopy = [...state.wgevents];
      if (wgeventsCopy.length !== 0) {
        wgeventsCopy.forEach((event, index) => {
          if (event._id === toBeRemovedId) {
            wgeventsCopy.splice(index, 1);
          }
        });
      }
      return {
        ...state,
        wgevents: wgeventsCopy,
      };
    }
    case GET_ALL_MARATHON_EVENTS: {
      return {
        ...state,
        allMarathonEvents: action.payload,
      };
    }
    case MARATHON_EVENTS_CURRENT_PAGE: {
      return {
        ...state,
        marathonEventsCurrentPage: action.payload,
      };
    }
    case MARATHON_EVENTS_TOTAL_PAGES: {
      return {
        ...state,
        marathonEventsTotalPages: action.payload,
      };
    }
    case GET_MARATHON_EVENT_BY_ID: {
      return {
        ...state,
        marathonEventById: action.payload,
      };
    }
    case GET_MARATHON_QUESTIONS_BY_ID: {
      return {
        ...state,
        marathonQuestionsById: action.payload,
      };
    }
    case ADD_MARATHON_QUESTION: {
      return {
        ...state,
        marathonQuestionsById: [...state.marathonQuestionsById, action.payload],
      };
    }
    case UPDATE_MARATHON_QUESTION: {
      return {
        ...state,
        marathonQuestionsById: state.marathonQuestionsById.map((question) =>
          question._id === action.payload.id
            ? action.payload.question
            : question
        ),
      };
    }
    case REMOVE_MARATHON_QUESTION: {
      return {
        ...state,
        marathonQuestionsById: state.marathonQuestionsById.filter(
          (question) => question._id !== action.payload
        ),
      };
    }
    case GET_MARATHON_TICKET_LIST: {
      return {
        ...state,
        marathonTicketList: action.payload,
      };
    }
    case MARATHON_TICKET_LIST_CURRENT_PAGE: {
      return {
        ...state,
        marathonTicketListCurrentPage: action.payload,
      };
    }
    case MARATHON_TICKET_LIST_TOTAL_PAGES: {
      return {
        ...state,
        marathonTicketListTotalPages: action.payload,
      };
    }
    case REMOVE_MARATHON_SINGLE_TICKET: {
      return {
        ...state,
        marathonTicketList: state.marathonTicketList.filter(
          (item) => item._id !== action.payload
        ),
      };
    }
    case GET_MARATHON_ANSWER: {
      return {
        ...state,
        marathonAnswer: action.payload,
      };
    }
    case GET_MARATHON_SCORES: {
      return {
        ...state,
        marathonScores: action.payload,
      };
    }
    case MARATHON_SCORES_CURRENT_PAGE: {
      return {
        ...state,
        marathonScoresCurrentPage: action.payload,
      };
    }
    case MARATHON_SCORES_TOTAL_PAGES: {
      return {
        ...state,
        marathonScoresTotalPages: action.payload,
      };
    }
    case UPDATE_MARATHON_SCORE: {
      return {
        ...state,
        marathonScores: state.marathonScores.map((item) =>
          item._id === action.payload.id
            ? {
                ...item,
                score: action.payload.score.score,
                gameTimeInSeconds: action.payload.score.gameTimeInSeconds,
              }
            : item
        ),
      };
    }
    default:
      return state;
  }
};
